import axios from 'axios';

const api = axios.create({
  baseURL: '/api/cashflow',
  headers: { 'Content-Type': 'application/json' },
});

export default api;
